import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import Dashboard from "../ModuleManagement/MM_partial_Dashboard";
import ModulesSummary from "../ModuleManagement/MM_partial_ModulesSummary";
const ModuleManagement = () => {
//   useEffect(() => {
//     Swal.fire({
//         icon: "warning",
//         title: "Reminder to all users",
//         text: "This page is currently intended for testing only. For any concerns, please reach out to the development team.",
//         confirmButtonColor: '#A5CC2D', 
//       });
//   }, []);
  
  return (
      <div className="app-container">
         <div className="container">
            <div className='jumbotron'>
                <h1 className='title'>Module Access Management</h1>
            </div>
            <br/>
            <Dashboard/>
            <div className="app-column">
                <ModulesSummary/>
            </div>
            <label className="custom-footer">© 2025 Pacific Debt Relief. All rights reserved. </label>
            <br/> <br/> <br/> <br/>
          </div> 
      </div>
  );
};

export default ModuleManagement;